import { authService } from './auth.service';
import axiosInstance from './axiosConfig';

export interface Branch {
  branch_id: string;
  branch_code: string;
  branch_name: string;
  location: string;
  phone: string;
  currency_code: string;
  currency_symbol: string;
  tax_rate: number;
  base_currency: string;
  is_default_branch: boolean;
}

export interface UserBranchPreferences {
  branch: Branch;
  currency: {
    code: string;
    symbol: string;
    tax_rate: number;
    base_currency: string;
  };
}

class UserBranchPreferencesService {

  // Get user's default branch and currency info
  async getUserDefaultBranch(): Promise<UserBranchPreferences> {
    try {
      const { data } = await axiosInstance.get<UserBranchPreferences>(
        '/user-branch-preferences/default'
      );
      return data;
    } catch (error) {

      throw error;
    }
  }

  // Set user's default branch
  async setUserDefaultBranch(
    branchId: string,
    preferredCurrencyDisplay: string = 'branch'
  ): Promise<any> {
    try {
      const { data } = await axiosInstance.post(
        '/user-branch-preferences/default',
        {
          branch_id: branchId,
          preferred_currency_display: preferredCurrencyDisplay,
        }
      );
      return data;
    } catch (error) {

      throw error;
    }
  }

  // Get user's accessible branches
  async getUserAccessibleBranches(): Promise<Branch[]> {
    try {
      const { data } = await axiosInstance.get<Branch[]>(
        '/user-branch-preferences/accessible'
      );
      return data;
    } catch (error) {

      throw error;
    }
  }

  // Get branch currency info
  async getBranchCurrencyInfo(branchId: string): Promise<any> {
    try {
      const { data } = await axiosInstance.get(
        `/user-branch-preferences/branch/${branchId}/currency`
      );
      return data;
    } catch (error) {

      throw error;
    }
  }

  // Format currency amount
  formatCurrency(amount: number, currencyCode: string, currencySymbol: string): string {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    
    return formatter.format(amount);
  }

  // Calculate tax amount
  calculateTaxAmount(subtotal: number, taxRate: number): number {
    return (subtotal * taxRate) / 100;
  }

  // Calculate total with tax
  calculateTotalWithTax(subtotal: number, taxRate: number): number {
    return subtotal + this.calculateTaxAmount(subtotal, taxRate);
  }
}

export const userBranchPreferencesService = new UserBranchPreferencesService(); 